import { useWeb3React } from "@web3-react/core";
import toast from "react-hot-toast";
import React, { useState } from "react";
import Popup from "reactjs-popup";
import { useContract } from "../../helpers/use-connector";
import Loader from "../../loader";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { getUrl } from "../../hooks/axiosInstance";
import { TiEdit } from "react-icons/ti";
import { useEffect } from "react";
const EditDescription = ({ getAssetData, description }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
  const [descriptionIn, setDescriptionIn] = useState();
  const { account } = useWeb3React();
  const { tokenId } = useParams();
  useEffect(() => {
    if (description) {
      setDescriptionIn(description);
    }
  }, [description]);
  // const { mediaContract } = useContract();

  // const handlePublishingAsset = async (close) => {
  //   if (account && mediaContract) {
  //     try {
  //       setLoading(true);
  //       const res = await mediaContract.methods
  //         .removeBid(tokenId)
  //         .send({ from: account });

  //       if (res?.status) {
  //         toast.success("Bid removed Successfully.");
  //       }
  //       getAssetData();
  //       setLoading(false);
  //       close();
  //     } catch (err) {
  //       if (err?.message) {
  //         toast.error(err.message);
  //         setLoading(false);
  //         close();
  //       } else {
  //         toast.error("something went wrong");
  //         setLoading(false);
  //         close();
  //       }
  //     }
  //   }
  // };
  const handleRemoveAsset = async (e, close) => {
    e.preventDefault();
    try {
      const res = await axios.post(
        `${getUrl()}/api/updatenft`,
        {
          tokenId: tokenId,
          description: descriptionIn,
        },
        { withCredentials: true }
      );

      if (res?.status === 200) {
        toast.success("Asset updated successfully.");
        setLoading(false);
        getAssetData();
        close();
        // navigate(`/account/${account}`);
      }
    } catch (err) {
      if (err?.response?.data) {
        console.log("err", err?.response?.data?.message);
        toast.error(err?.response?.data?.message);
        setLoading(false);
        close();
      } else {
        toast.error("something went wrong");
        setLoading(false);
        close();
      }
    }
  };
  return (
    <Popup
      modal={true}
      trigger={
        <div
          style={{ cursor: "pointer" }}
          className="edit-asset-button-hover"
          // onClick={() => {
          //   alert("work");
          // }}
        >
          <TiEdit size={25} />
        </div>
      }
      position="center"
    >
      {(close) => (
        <div className="bft-content">
          {!loading ? (
            <>
              <h4>
                You are Editing Description
                <i
                  className="fa fa-times pointer bft-right bft-large bft-text-red"
                  onClick={close}
                ></i>
              </h4>
              <hr />

              <div style={{ paddingTop: "10px" }}>
                <form
                  onSubmit={(e) => {
                    handleRemoveAsset(e, close);
                    // handlePublishingAsset(e, close);
                  }}
                >
                  <label htmlFor="cover" style={{ padding: "5px 0" }}>
                    Description
                  </label>
                  <textarea
                    rows={2}
                    type="text"
                    id="editAsset"
                    className="bft-input"
                    placeholder="Description"
                    name="editAsset"
                    value={descriptionIn}
                    onChange={(e) => {
                      setDescriptionIn(e.target.value);
                    }}
                    style={{ border: "1px solid gray" }}
                    required
                  />

                  <input
                    type="submit"
                    className="bft-input bft-btn bft-color"
                    value="Update Asset"
                    style={{ color: "#fff" }}
                  />
                </form>
              </div>
            </>
          ) : (
            <div className="bft-center">
              <h1>Waiting for Transaction...</h1>
              <Loader />
            </div>
          )}
        </div>
      )}
    </Popup>
  );
};

export default EditDescription;
